import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Icona from 'components/corporatiu/ui/Icona';
import __isEmpty from 'lodash/isEmpty';
import styles from './dropdown.module.scss';

const Dropdown = (props) => {
    const { className, estil, textSelector, items, updateDropdown, ariaLabel = 'Obrir desplegable' } = props;
    const [openDropdown, setOpenDropdown] = useState(false);
    const [label, setLabel] = useState(textSelector);
    const refDropDown = useRef();

    const stylesDropdown = clsx({
        [styles.wrapper]: true,
        [styles.open]: openDropdown,
        [styles[estil]]: !__isEmpty(estil),
        [[className]]: !__isEmpty(className)
    });

    const handleKeyDown = (event, item, labelItem) => {
        if (event.key === 'Enter') {
            updateDropdown(item);
            setLabel(labelItem);
            setOpenDropdown(false);
        }
    };

    const itemsDropdown = () => {
        return items.map((item) => {
            const labelItem = item.desc || item.titol;
            const stylesItem = clsx({
                [styles.item]: true,
                [styles.selected]: label === labelItem
            });
            return (
                <li key={item.id} className={styles.itemLlista}>
                    <button
                        aria-current={label === labelItem}
                        onKeyDown={(e) => handleKeyDown(e, item, labelItem)}
                        onClick={() => {
                            updateDropdown(item);
                            setLabel(labelItem);
                        }}
                        className={stylesItem}
                        data-testid={`dropdown-${item.id}`}
                    >
                        {labelItem}
                    </button>
                </li>
            );
        });
    };

    useEffect(() => {
        setLabel(textSelector);
    }, [textSelector]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!refDropDown?.current?.contains(event.target)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside, { passive: true });
        document.addEventListener('touchstart', handleClickOutside, { passive: true });

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [refDropDown]);

    return (
        <div className={stylesDropdown} ref={refDropDown}>
            <button
                onClick={() => setOpenDropdown(!openDropdown)}
                className={styles.dropdown}
                aria-label={ariaLabel}
                aria-haspopup={true}
                aria-expanded={openDropdown ? true : false}
                data-testid='dropdown-button-desplegable'
            >
                <div className={styles.dropdown_text}>{label}</div>
                <Icona className={styles.drowpdown_icona} icona='fletxa_simple_avall' alt='fletxa desplegar' />
            </button>
            <div className={styles.dropWrapper} onClick={() => setOpenDropdown(false)}>
                <ul data-testid='dropdown' role='menu' className={styles.llistaDropdown}>
                    {itemsDropdown()}
                </ul>
            </div>
        </div>
    );
};

export default Dropdown;
